import { render, staticRenderFns } from "./RiskAuditAdd.vue?vue&type=template&id=4d3046b8&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./RiskAuditAdd.vue?vue&type=script&lang=js&"
export * from "./RiskAuditAdd.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports